import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { EnvConfigurationService } from 'src/app/service/env-config.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-sensorstations-map',
  templateUrl: './sensorstations-map.component.html',
  styleUrls: ['./sensorstations-map.component.scss'],
  standalone: false,
  providers: [DatePipe],
})
export class SensorstationsMapComponent implements OnInit, OnDestroy {
  public url: string;

  private resizeListener: () => void;

  constructor(
    public envService: EnvConfigurationService,
    private elementRef: ElementRef,
    private http: HttpClient
  ) {
    // URL will be set after session cookie is primed
    this.url = '';
  }

  // Method to change the URL dynamically
  public changeUrl(newUrl: string) {
    this.url = newUrl;
  }

  async ngOnInit(): Promise<void> {
    this.resizeListener = this.updateIframeHeight.bind(this);
    window.addEventListener('resize', this.resizeListener);
    try {
      await this.http
        .get(`${this.envService.config.sensorstationMap}/api/health`, {
          withCredentials: true,
        })
        .toPromise();
    } catch (e) {
      console.warn('Preflight to Grafana failed (ignored):', e);
    }
    this.url = `${this.envService.config.sensorstationMap}`;
    this.setIframeHeight();
  }

  private setIframeHeight(): void {
    const iframe = this.elementRef.nativeElement.querySelector(
      '#sensorstation-map'
    ) as HTMLIFrameElement;
    if (iframe) {
      this.updateIframeHeight();
    }
  }

  private updateIframeHeight(): void {
    const iframe = this.elementRef.nativeElement.querySelector(
      '#sensorstation-map'
    ) as HTMLIFrameElement;
    if (iframe) {
      const screenHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;
      iframe.style.height = `${screenHeight - 185}px`;
    }
  }

  ngOnDestroy(): void {
    if (this.resizeListener) {
      window.removeEventListener('resize', this.resizeListener);
    }
  }
}
